<script setup>
import { ref, computed } from 'vue'

import 'devextreme-vue/text-area'
import { DxTreeList } from 'devextreme-vue/tree-list'

import * as dataGrid from '@/composables/data-grid'

import { useColumns } from '@/composables/garage/service-history-row-grid'

import { garageApi } from '@/apis/garage.api'
import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'
import { useGarageStore } from '@/stores/garage.store'

import ProductDropDownBox from '@/components/shared/ProductDropDownBox.vue'

const props = defineProps({
  data: Object
})

const emits = defineEmits(['content-ready'])

const worksheetId = props.data?.key

const saveStateId = `service-history-row-grid`
const gridId = `${saveStateId}_${worksheetId}`

const computedDataSource = computed(() => {
  const worksheet = props.data?.key
  return dataGrid.useODataSource(
    garageApi.getAbsoluteUrl() + garageApi.worksheetRowsUrl,
    {
      customParamsFn: () => { return { $notop: true, worksheet: worksheet } },
      avoidDuplicateDatasourceIds: true
    }
  )
})

const registryStore = useRegistryStore()
const webSiteStore = useWebSiteStore()
const garageStore = useGarageStore()

const documentRowType = ref(null)
const supplierBrand = ref(registryStore.supplierBrands.find(i => i.id === props.data?.data?.supplier_brand_ref))
const currency = webSiteStore.currencies.find(i => i.id === props.data?.data?.currency_ref)

const columns = useColumns(supplierBrand, currency, documentRowType)

const gridOptions = dataGrid.useDefaultGridOptions({
  id: gridId,
  saveStateId: saveStateId,
  mode: 'row',
  columns: columns,
  height: '100%',
  onContentReady: (e) => { emits('content-ready', e) },
  disabledFocusOnContentReady: true,
  // Tree grid mandatory options
  remoteOperations: 'false',
  parentIdExpr: 'parent_id',
  dataStructure: 'plain',
  scrolling: { mode: 'standard' },
  paging: {
    enabled: false
  },
})

</script>
<template>
  <div>
    <dx-tree-list
      ref="gridRef"
      :key="gridId"
      v-bind="gridOptions"
      :data-source="computedDataSource"
    >
      <template #productEditor="{ data: cellInfo }">
        <product-drop-down-box
          :brand="supplierBrand"
          :document-row-type="documentRowType"
          :disabled="documentRowType?.type === webSiteStore.documentRowTypesEnum.TEXT"
          :data="cellInfo"
        />
      </template>
      <template #processingType="{ data: cellInfo }">
        <div :class="{ 'text-grey-7 text-italic': cellInfo.data.processing_type === garageStore.processingTypesEnum.DETAIL }">
          {{ cellInfo.displayValue }}
        </div>
      </template>
    </dx-tree-list>
  </div>
</template>
<style>
</style>
